<template>
  <DashboardContentLayout>
    <div></div>
  </DashboardContentLayout>
</template>
